var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { WidgetContext } from "../../../../Widget";
import { Button, Modal } from "@brushfire/ui";
import { platformAwareRedirect } from "../../../../../data/helpers";
import Constants from "../../../../../data/constants";
import { setCartData } from "../../../../../store/Cart/actions";
import { useDispatch } from "react-redux";
import { setFormIsSubmitting } from "../../../../../store/AppState/actions";
var CartExpiredModal = function (_a) {
    var show = _a.show, setShow = _a.setShow;
    var params = useParams();
    var history = useHistory();
    var dispatch = useDispatch();
    var isWidget = useContext(WidgetContext).isWidget;
    return (_jsx(Modal, __assign({ closeButton: false, size: "sm", show: show, setShow: setShow, disableClose: true }, { children: _jsxs(_Fragment, { children: [_jsx("h6", __assign({ className: "ta-center" }, { children: "Your cart has been emptied because your session expired." })), _jsx("div", __assign({ className: "modal-footer border-0 p-0 p-top" }, { children: _jsx(Button, __assign({ type: "submit", purpose: "primary", classes: "btn-sm btn-block p-0 m-0", onClick: function () {
                            platformAwareRedirect(Constants.Routes.eventStart
                                .replace(":clientKey", params.clientKey)
                                .replace(":urlKey", params.urlKey)
                                .replace(":eventNumber", params.eventNumber), isWidget, history);
                            setShow(false);
                            dispatch(setCartData(undefined));
                            dispatch(setFormIsSubmitting(false));
                        } }, { children: "Continue" })) }))] }) })));
};
export default CartExpiredModal;
